import { ReactNode, useCallback } from 'react';

import { EmergencyNotificationAcknowledgeCommand } from '@dreryk/egabinet-emergency-notification-frontend-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import { ActionEventInterceptor } from '@dreryk/react-components';
import { Slot } from '@dreryk/watermelon';

type EmergencyNotificationAcknowledgeActionInterceptorProps = {
   readonly children: ReactNode;
   readonly notificationId?: number;
   readonly onSuccess?: (notificationId?: number) => void;
};

export const EmergencyNotificationAcknowledgeActionInterceptor = (
   props: EmergencyNotificationAcknowledgeActionInterceptorProps
): JSX.Element => {
   const { executeAsync: acknowledgeEmergencyNotification } = useCqrsCommand<void, number | undefined>(
      (notificationId) => {
         const command = new EmergencyNotificationAcknowledgeCommand();
         command.notificationId = Slot.emptyIfNull(notificationId ?? null);
         return command;
      },
      {
         onSuccess: (__, notificationId) => {
            return props.onSuccess?.(notificationId);
         },
      }
   );

   const handleAction = useCallback(async () => {
      await acknowledgeEmergencyNotification(props.notificationId);
   }, [props.notificationId, acknowledgeEmergencyNotification]);

   return <ActionEventInterceptor action={handleAction}>{props.children}</ActionEventInterceptor>;
};
